// Libs
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Sentry } from "@collectivehealth/cog";

// Constants
export const DATA_HOOK = "ErrorBoundary";

/**
 * Component used to gracefully capture errors thrown by its child component(s).
 * See https://reactjs.org/docs/error-boundaries.html for more info.
 * @public
 * @class
 */
export default class ErrorBoundary extends Component {
  static propTypes = {
    message: PropTypes.node
  };

  static defaultProps = {
    message: (
      <>
        <h1>Oops! Something went wrong.</h1>
        <p>Check the console for more information.</p>
      </>
    )
  };

  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error, errorInfo) {
    Sentry.captureException(error);
    this.setState({
      error,
      errorInfo
    });
  }

  render() {
    const { errorInfo } = this.state;

    if (errorInfo) {
      return <div data-hook={DATA_HOOK}>{this.props.message}</div>;
    }

    return this.props.children;
  }
}
